module.exports = __webpack_public_path__ + "media/no.06d23cf2.mp3";